import { useEffect, useState } from "react";

import useStateHandler from "@/hooks/useStateHandler";
import UserService from "@/services/user.service";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import ImageCropper from "./ImageCropper";

import "./styles/PopupUpdateProfilePicture.css";

const PopupUpdateProfilePicture = ({ open, image, exitCrop, cropAreaClass, setCroppedUrl }) => {
  const { state, stateHandler } = useStateHandler();

  const userType = state?.user_session?.user_type;
  const cropShape = userType === 'gallery' ? 'rect' : 'circle';

  const [imageFile, setImageFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleProfilePictureUpdate = async (croppedImage) => {
    setIsLoading(true);

    // Upload the image to the server
    const { response, data } = await UserService.uploadImage(croppedImage);

    if (response.ok) {
      await UserService.editProfile({ 
        ...state.user_session, 
        user_image: data 
      });

      stateHandler.set("user_session", { 
        ...state.user_session, 
        user_image: data 
      });

      stateHandler.set("temporalPopup", {
        text: "Profile picture updated successfully!",
        type: "navbar-present"
      });

      exitCrop();
    } else {
      alert("There was an error updating your profile picture. Please try again.");
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (imageFile) {
      handleProfilePictureUpdate(imageFile);
    }
  }, [imageFile]);

  return (
    <GenericPopup
      open={open}
      className={`profile-picture__crop-popup ${cropAreaClass}`}
    >
      <div className="profile-picture__header" >
        <p className="profile-picture__header-text">
          Update Profile Picture
        </p>
        <p className="profile-picture__instructions">
          Adjust and crop your profile picture
        </p>
      </div>
      <ImageCropper
        source={image}
        width={200}
        height={200}
        cropShape={cropShape}
        exitCrop={exitCrop}
        setCroppedFile={setImageFile}
        setCroppedUrl={setCroppedUrl}
        isLoading={isLoading}
      />
    </GenericPopup>
  );
};

export default PopupUpdateProfilePicture;
